import {useMutation, useQueryClient} from '@tanstack/react-query'
import {MUTATION_KEYS, QUERY_KEYS} from './keys'
import {QUERY_KEYS as CHAT_QUERY_KEYS} from '@/features/chat/queries/keys'
import {QUERY_KEYS as MEMBERSHIP_QUERY_KEYS} from '@/features/configure-membership-plans/edit-configure-membership-plans-modal/queries/keys'
import {unSubscribeFromHostV3} from '../services/recurringGift.http'

export const useUnSubscribeFromHostV3 = (subscriptionId: string) => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationKey: [MUTATION_KEYS.unsubscribe, subscriptionId],
        mutationFn: () => unSubscribeFromHostV3(subscriptionId),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: [CHAT_QUERY_KEYS.fetchChannelDetailsV3]})
            queryClient.invalidateQueries({queryKey: [QUERY_KEYS.subscribedHostsV3]})
            queryClient.invalidateQueries({queryKey: [MEMBERSHIP_QUERY_KEYS.membership_plans]})
        }
    })
}
